import { useEffect, useState } from 'react';

const AWST = 'Australia/Perth';

/** Pinned to the corner on every page, so it's always clear what timezone every timestamp in this app is shown in. */
export function TimezoneBadge() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', timeZone: AWST });

  return (
    <div className="timezone-badge" title="All dates and times in this app are shown in Australian Western Standard Time">
      AWST · {time}
    </div>
  );
}
